module.exports = __webpack_public_path__ + "img/b1.f7f6f789.jpg";